export default function stickyNav() {
	let jumpNav = $('#jumpNav');
	let jumpLink = $('.jumpLink');
	let alerts = $('.alerts');
	let jumpSlider = $('.jumpNav__slider');
	let slides = $('.jumpNav_anchor');
	if (slides.length >= 5) {
		jumpSlider.addClass('jumpNav__slider--moreThanFour');
	} else if (slides.length === 4) {
		jumpSlider.addClass('jumpNav__slider--moreThanThree');
	}

	function slideNavMobile() {
		let windowWidth = window.innerWidth;
		if (windowWidth < 550) {
			jumpSlider.slick({
				arrows: false,
				autoplay: false,
				dots: false,
				infinite: false,
				accessibility: true,
				centerMode: false,
				slidesToScroll: 1,
				slidesToShow: 1,
			});
		} else if (jumpSlider.hasClass('slick-initialized') && windowWidth > 550) {
			jumpSlider.slick('unslick');
		}
	}

	slideNavMobile();
	window.addEventListener('resize', slideNavMobile);

	if (jumpLink.length > 0) {
		let jLinks = document.querySelectorAll('.jumpLink');

		jLinks.forEach((el) =>
			el.addEventListener('click', (event) => {
				event.preventDefault();
				let id = el.getAttribute('data-id');
				let targetBlock = document.getElementById(id);
				targetBlock.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			})
		);
	}

	if (jumpSlider.length > 0 && alerts.length > 0) {
		let anchors = jumpSlider.find('.jumpNav_anchor');
		let header = $('#header-nav');
		$(window).scroll(function () {
			let sticky = jumpNav[0].offsetTop - alerts.height();
			let height = alerts.height() + $('.header__wrap').height() + 10;
			if (window.pageYOffset >= sticky) {
				$('.jumpNav-wrapper').css('top', height + 'px');
				jumpNav.addClass('sticky-jumpNav');
				header.addClass('header__stickyNav');
			} else {
				$('.jumpNav-wrapper').css('top', -30 + 'px');
				jumpNav.removeClass('sticky-jumpNav');
				header.removeClass('header__stickyNav');
			}
		});
		anchors.click((event) => {
			event.preventDefault();
			let targetElement = document.querySelector(event.target.hash);

			// Calculate the scroll position
			let scrollPosition =
				targetElement.getBoundingClientRect().top + window.pageYOffset - 210;

			// Scroll to the calculated position
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		});
	} else if (jumpNav.length > 0 && alerts.length < 1) {
		let sticky = jumpNav[0].offsetTop - 40;
		let anchors = jumpSlider.find('.jumpNav_anchor');
		let header = $('#header-nav');
		$(window).scroll(function () {
			if (window.pageYOffset >= sticky) {
				$('.jumpNav-wrapper').css('top', 80 + 'px');
				jumpNav.addClass('sticky-jumpNav');
				header.addClass('header__stickyNav');
			} else {
				$('.jumpNav-wrapper').css('top', -30 + 'px');
				jumpNav.removeClass('sticky-jumpNav');
				header.removeClass('header__stickyNav');
			}
		});
		anchors.click((event) => {
			event.preventDefault();
			let targetElement = document.querySelector(event.target.hash);

			// Calculate the scroll position
			let scrollPosition =
				targetElement.getBoundingClientRect().top + window.pageYOffset - 210;

			// Scroll to the calculated position
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		});
	}
}
